module.exports = __webpack_public_path__ + "static/media/utilita2.a71a1565.png";